export default __webpack_public_path__ + "static/media/Visual 13.7b37f5d6.jpeg";